import CHANGE_BUSINESS from './changeBusiness.gql';
import ME_BUSINESS_ID from './meBusinessId.gql';
import LOAN_AVAILABLE_FOR_PROMO_RENEGOTIATE from './loanAvailableForPromoRenegotiate.gql';

export {
  CHANGE_BUSINESS,
  LOAN_AVAILABLE_FOR_PROMO_RENEGOTIATE,
  ME_BUSINESS_ID,
};
